import { render, staticRenderFns } from "./wallet-withdrawal-details.vue?vue&type=template&id=6b86724a"
import script from "./wallet-withdrawal-details.vue?vue&type=script&lang=js"
export * from "./wallet-withdrawal-details.vue?vue&type=script&lang=js"
import style0 from "./wallet-withdrawal-details.vue?vue&type=style&index=0&id=6b86724a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports